module.exports = __webpack_public_path__ + "img/pigai-icon-01.611e11ed.png";